/* The Bath & Care — product interactions (Shopify) */
(function () {
  'use strict';

  // FIX (Issue 1): this used to be `var TBC = window.TBC || {};`
  // That created a brand-new local object whenever this script ran BEFORE
  // the inline <script> at the bottom of tbc-main-product.liquid populated
  // window.TBC.variants / window.TBC.options. Every closure below (selectOption,
  // updateVariant, currentVariant, buyNow) then held a reference to that empty
  // object forever — so TBC.variants was always undefined and variant changes
  // never updated anything (PDP price, sticky bar, or Buy Now).
  // Assigning back to window.TBC guarantees both point to the SAME object,
  // so later `window.TBC.variants = {{ p.variants | json }}` is visible here too.
  var TBC = window.TBC = window.TBC || {};

  var state = { qty: 1, mode: 'onetime', optionValues: [] };

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var fmt = TBC.moneyFormat || '₹{{amount}}';
    var value = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, value); 
  }

  window.buyNow = function () {
    var v = currentVariant();
    if (!v || !v.available) return;

    // FIX: was return_to=/cart — Buy Now should land on checkout, not the cart page.
    window.location.href = '/cart/add?id=' + v.id + '&quantity=' + state.qty + '&return_to=' + encodeURIComponent('/checkout');
  };

  /* ---------- Variant matching ---------- */
  function currentVariant() {
    if (!TBC.variants) return null;
    if (TBC.variants.length === 1) return TBC.variants[0];
    return TBC.variants.find(function (v) {
      return state.optionValues.every(function (val, i) {
        return val == null || v.options[i] === val;
      });
    }) || TBC.variants[0];
  }

  function updateVariant() {
    var v = currentVariant();
    if (!v) return;

    var idEl = document.getElementById('variantId');
    if (idEl) idEl.value = v.id;

    // NOTE: price elements are no longer targeted via getElementById, because
    // the template renders TWO price rows (one near the top, one right above
    // the add-to-cart form) that share the same classes. getElementById only
    // ever returns the first match in the DOM, so previously only the top
    // price block updated on variant change. querySelectorAll + forEach below
    // updates every instance on the page.
    document.querySelectorAll('.js-price-main').forEach(function (el) {
      el.textContent = formatMoney(v.price);
    });

    var hasCompare = !!(v.compare_at_price && v.compare_at_price > v.price);
    var pct = hasCompare
      ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100)
      : 0;

    document.querySelectorAll('.js-price-old').forEach(function (el) {
      if (hasCompare) {
        el.textContent = formatMoney(v.compare_at_price);
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    document.querySelectorAll('.js-price-badge').forEach(function (el) {
      if (hasCompare) {
        el.textContent = 'Save ' + pct + '%';
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    var atcBtn = document.querySelector('.btn-atc');
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
    }

    var buyNowBtn = document.querySelector('.btn-buynow');
    if (buyNowBtn) {
      buyNowBtn.disabled = !v.available;
    }

    var stockRow = document.getElementById('stockRow');
    if (stockRow) {
      stockRow.innerHTML = v.available
        ? '<span class="stock-dot"></span> In stock — ships in 24 hours'
        : '<span class="stock-dot" style="background:#E0444E;box-shadow:0 0 0 3px rgba(224,68,78,.15)"></span> Out of stock';
    }

    // one-time purchase price shown inside the buy-modes UI also needs to
    // track the selected variant (it was previously static on load)
    var onetimePrice = document.querySelector('.buy-mode[data-mode="onetime"] .buy-mode-price');
    if (onetimePrice) onetimePrice.textContent = formatMoney(v.price);

    var subPriceEl = document.querySelector('.buy-mode[data-mode="subscribe"] .buy-mode-price');
    if (subPriceEl) {
      var discountPct = TBC.subDiscount || 15;
      var subUnit = Math.round(v.price * (100 - discountPct) / 100);
      var strikeEl = subPriceEl.querySelector('.strike');
      if (strikeEl) {
        strikeEl.textContent = formatMoney(v.price);
        subPriceEl.innerHTML = strikeEl.outerHTML + formatMoney(subUnit);
      } else {
        subPriceEl.textContent = formatMoney(subUnit);
      }
    }

    refreshPrice(v);
  }

  function refreshPrice(v) {
    v = v || currentVariant(); if (!v) return;
    var unit = state.mode === 'subscribe'
      ? Math.round(v.price * (100 - (TBC.subDiscount || 15)) / 100)
      : v.price;
    var sticky = document.getElementById('stickyPrice');
    if (sticky) sticky.textContent = formatMoney(unit * state.qty);
  }

  /* ---------- Option selection ---------- */
  window.selectOption = function (btn) {
    var idx = parseInt(btn.dataset.optionIndex, 10);
    document.querySelectorAll('.size-btn[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    state.optionValues[idx] = btn.dataset.value;
    updateVariant();
  };

  /* ---------- Quantity ---------- */
  window.changeQty = function (d) {
    state.qty = Math.max(1, state.qty + d);
    var q = document.getElementById('qty'); if (q) q.textContent = state.qty;
    var qi = document.getElementById('qtyInput'); if (qi) qi.value = state.qty;
    refreshPrice();
  };

  /* ---------- Purchase mode ---------- */
  window.selectMode = function (el) {
    document.querySelectorAll('.buy-mode').forEach(function (m) { m.classList.remove('active'); });
    el.classList.add('active');
    state.mode = el.dataset.mode;
    refreshPrice();
  };

  /* ---------- Tabs ---------- */
  window.switchTab = function (btn, id) {
    document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
    document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
    btn.classList.add('active');
    var el = document.getElementById(id); if (el) el.classList.add('active');
  };

  /* ---------- FAQ ---------- */
  window.toggleFaq = function (el) {
    var a = el.nextElementSibling, arrow = el.querySelector('.faq-arrow');
    var open = a.classList.contains('open');
    document.querySelectorAll('.faq-a').forEach(function (x) { x.classList.remove('open'); });
    document.querySelectorAll('.faq-arrow').forEach(function (x) { x.classList.remove('open'); });
    if (!open) { a.classList.add('open'); arrow.classList.add('open'); }
  };

  /* ---------- Gallery ---------- */
  window.swapGallery = function (thumb, full) {
    document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    var img = document.getElementById('galleryMainImg');
    if (img && full) img.src = full;
    var lb = document.getElementById('lightboxImg');
    if (lb && full) lb.src = full;
  };
  window.openLightbox = function () { var l = document.getElementById('lightbox'); if (l) l.classList.add('open'); };
  window.closeLightbox = function (e) {
    if (e.target.id === 'lightbox' || e.target.classList.contains('lightbox-close')) {
      document.getElementById('lightbox').classList.remove('open');
    }
  };

  /* ---------- Coupon copy ---------- */
  window.copyCode = function (el, code) {
    if (navigator.clipboard) navigator.clipboard.writeText(code);
    var orig = el.textContent;
    el.textContent = 'Copied ✓'; el.classList.add('copied');
    setTimeout(function () { el.textContent = orig; el.classList.remove('copied'); }, 1500);
  };

  /* ---------- Pincode check ---------- */
  window.checkPincode = function () {
    var pin = (document.getElementById('pincode') || {}).value || '';
    pin = pin.trim();
    var result = document.getElementById('deliveryResult');
    var text = document.getElementById('deliveryResultText');
    if (!result) return;
    result.classList.add('show');
    var dot = result.querySelector('.delivery-result-dot');
    if (!/^\d{6}$/.test(pin)) {
      dot.style.background = '#E0444E';
      text.textContent = 'Please enter a valid 6-digit pincode.';
      return;
    }
    var days = (parseInt(pin[0], 10) % 4) + 2;
    dot.style.background = '#2B9D5B';
    text.innerHTML = 'Delivers to <strong>' + pin + '</strong> in ' + days + '–' + (days + 1) + ' days · COD available';
  };

  /* ---------- Before / After ---------- */
  var baRange = document.getElementById('baRange');
  if (baRange) {
    baRange.addEventListener('input', function (e) {
      var v = e.target.value;
      document.getElementById('baBefore').style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      document.getElementById('baDivider').style.left = v + '%';
      document.getElementById('baHandle').style.left = v + '%';
    });
  }

  /* ---------- Routine builder ---------- */
  window.toggleRoutine = function (card) {
    card.classList.toggle('selected');
    card.querySelector('.routine-check').textContent = card.classList.contains('selected') ? '✓' : '';
    recalcRoutine();
  };
  function recalcRoutine() {
    var grid = document.getElementById('routineGrid'); if (!grid) return;
    var min = parseInt(grid.dataset.bundleMin, 10) || 3;
    var bundlePrice = parseFloat(grid.dataset.bundlePrice) || 0;
    var selected = grid.querySelectorAll('.routine-card.selected');
    var total = 0;
    selected.forEach(function (c) { total += parseFloat(c.dataset.price) || 0; });
    var totalEl = document.getElementById('routineTotal');
    var saveEl = document.getElementById('routineSave');
    if (selected.length >= min) {
      totalEl.textContent = formatMoney(bundlePrice * 100);
      saveEl.textContent = 'You save ' + formatMoney(Math.max(0, total - bundlePrice) * 100);
    } else {
      totalEl.textContent = formatMoney(total * 100);
      saveEl.textContent = 'Add ' + (min - selected.length) + ' more to save';
    }
  }
  window.addRoutineToCart = function () {
    var grid = document.getElementById('routineGrid'); if (!grid) return;
    var items = [];
    grid.querySelectorAll('.routine-card.selected').forEach(function (c) {
      if (c.dataset.vid) items.push({ id: parseInt(c.dataset.vid, 10), quantity: 1 });
    });
    if (!items.length) return;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { alert('Could not add bundle. Please try again.'); });
  };

  /* ---------- Scroll reveal ---------- */
  (function () {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- Sticky bar ---------- */
  var addRow = document.querySelector('.add-row');
  var stickyBar = document.getElementById('stickyBar');
  if (addRow && stickyBar) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { stickyBar.classList.toggle('visible', !e.isIntersecting); });
    }, { threshold: 0 }).observe(addRow);
  }

  /* ---------- Filters (visual only) ---------- */
  document.querySelectorAll('.rfilter').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.rfilter').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* init */
  if (TBC.options) state.optionValues = TBC.options.map(function () { return null; });
  // seed from active buttons
  document.querySelectorAll('.size-btn.active').forEach(function (b) {
    state.optionValues[parseInt(b.dataset.optionIndex, 10)] = b.dataset.value;
  });
  refreshPrice();
  recalcRoutine();
})();
